export default {
  errorScreen: {
    actions: {
      createNewAppointment: 'Nieuwe afspraak maken',
      goBack: 'Sluiten',
    },
    header: 'Fout bij het boeken',
    messages: {
      default:
        'Er is een onverwachte fout opgetreden. Probeer het later opnieuw',
      internalServerError: 'Interne serverfout. Probeer het later opnieuw',
      network: 'Netwerkfout. Controleer uw verbinding en probeer het opnieuw.',
      noLocations: 'Geen locaties beschikbaar',
      zdCode: 'Ongeldige verwijzingscode',
    },
  },
  fields: {
    dateOfBirth: {
      error: 'Voer een geldige geboortedatum in',
      label: 'Geboortedatum',
      placeholder: 'DD/MM/YYYY',
    },
    email: {
      error: 'Voer een geldig e-mailadres in',
      label: 'E-mailadres',
      placeholder: 'john.doe@mail.com',
    },
    firstName: {
      error: 'Voer uw voornaam in',
      label: 'Voornaam',
      placeholder: 'John',
    },
    gender: {
      error: 'Selecteer uw geslacht',
      label: 'Geslacht',
      options: {
        female: 'Vrouw',
        male: 'Man',
        other: 'Anders',
        unknown: 'Onbekend',
      },
    },
    height: {
      error: 'Voer een geldige lengte in',
      label: 'Lengte (cm)',
    },
    initials: {
      error: 'Voer uw voorletters in',
      label: 'Voorletters',
      placeholder: 'JD',
    },
    lastName: {
      error: 'Voer uw achternaam in',
      label: 'Achternaam',
      placeholder: 'Doe',
    },
    phone: {
      error: 'Voer een geldig telefoonnummer in',
      label: 'Telefoonnummer',
      placeholder: 'XXX-XXX XXXX',
    },
    weight: {
      error: 'Voer een geldig gewicht in',
      label: 'Gewicht (kg)',
    },
  },
  navHeader: 'Maak een afspraak',
  successScreen: {
    actions: {
      close: 'Sluiten',
    },
    header: 'Afspraak bevestigd',
  },
}
